var _a;
import { SET_PLAYING, SET_CURRENT_DATE, SET_CURRENT_CAMERA_POSITION, SET_CURRENT_SCENARIO_SECONDS_PER_TICK } from './config';
export default (_a = {},
    _a[SET_PLAYING] = function (state, isPlaying) {
        state.isPlaying = isPlaying;
    },
    _a[SET_CURRENT_DATE] = function (state, currentDate) {
        state.currentDate = currentDate;
    },
    _a[SET_CURRENT_CAMERA_POSITION] = function (state, currentCameraPosition) {
        state.currentCameraPosition = currentCameraPosition;
    },
    _a[SET_CURRENT_SCENARIO_SECONDS_PER_TICK] = function (state, tick) {
        state.currentScenario.secondsPerTick = tick;
    },
    _a);
